import React from "react";
import ProfileHeader from "../ProfileHeader/ProfileHeader";

export default function HeaderSection({ setShowProfileView, activeChat, setActiveSection,
  onToggleSearch
}) {
  return (
    <>
      <header className="sticky top-4 mx-4 mt-4 rounded-full bg-white/80 dark:bg-slate-800/80 backdrop-blur-md z-10 min-h-[45px] py-2.5 flex items-center justify-between text-zinc-800 dark:text-zinc-100 px-6 shadow-sm border border-white/20 dark:border-slate-700/20">
        <ProfileHeader
          setShowProfileView={setShowProfileView}
          activeChat={activeChat}
          setActiveSection={setActiveSection}
          onToggleSearch={onToggleSearch}
        />
      </header>
    </>
  );
}
